import { createI18nText } from '@hilma/netina2all';

const siteIsClosedBanner = createI18nText({
	he: {
		text: 'הרכישה תפתח ב- ',
		subText: 'השאירו פרטים ונעדכן אתכם כשהרכישה תיפתח',
		leaveDetailsButton: 'השארת פרטים',
		leaveDetailsText: 'הרכישה הסתיימה לשנה זו, השאירו פרטים לקראת שנה הבאה',
		buyFromTelChaim: 'ניתן לקנות עוד השנה דרך עמותת טל חיים'
	},
	en: {
		text: 'Purchases can be made on ',
		subText: 'Leave your details and we will contact you when purchases can be made',
		leaveDetailsButton: 'Leave details',
		leaveDetailsText: 'Purchasing has ended for this year, please leave contact information for next year',
		buyFromTelChaim: 'You can still buy this year through Tal Chaim association'
	}
});

export default siteIsClosedBanner;